import * as React from "react";
import { useTranslation } from "react-i18next";

import { AtiraDatePicker } from "../AtiraDatePicker";
import { InputProps } from "./InputProps";
import styled from "styled-components";

const StyledDatePicker = styled(AtiraDatePicker)<{}>`
  &.ant-picker {
    box-shadow: var(--atira-box-shadow, none) !important;
  }

  .ant-picker-input > input::placeholder {
    color: var(--atira-placeholder-color, inherit) !important;
    opacity: var(--atira-placeholder-opacity, initial);
  }

  .ant-picker-suffix,
  .ant-picker-clear {
    color: inherit;
  }
`;

type RegularInputProps = InputProps & {
  ref?: React.Ref<HTMLInputElement>;
  inputType?: React.HTMLInputTypeAttribute;
  togglePasswordInputType: () => void;
};

export const RegularDateInputComponent: React.FC<
  Omit<RegularInputProps, "togglePasswordInputType">
> = ({ valid = true, ...props }) => {
  const { t } = useTranslation();

  return (
    <StyledDatePicker
      className={props.className}
      style={props.style}
      value={(props.value || null) as any}
      onChange={(date) => props.onChangeDate?.(date as any)}
      allowClear={props.required === false}
      required={props.required}
      placeholder={props.placeholder || t("common.select_date")}
      disabled={props.disabled}
      dataTestId={props.dataTestId}
      valid={valid}
      showTime={props.showTime}
      timezone={props.timezone}
    />
  );
};
